export const CHAT_SCROLL_BOTTOM_THRESHOLD = 24;

export const isScrollAtBottom = (element, threshold = CHAT_SCROLL_BOTTOM_THRESHOLD) => {
    if (!element) return true;

    return element.scrollHeight - element.scrollTop - element.clientHeight <= threshold;
};

export const findChatScrollContainer = (anchorNode) => {
    if (!anchorNode) return null;

    let parent = anchorNode.parentElement;
    while (parent) {
        const style = window.getComputedStyle(parent);
        const overflowY = style?.overflowY;
        const isScrollable =
            (overflowY === 'auto' || overflowY === 'scroll') &&
            parent.scrollHeight > parent.clientHeight;

        if (isScrollable) {
            return parent;
        }

        parent = parent.parentElement;
    }

    return document.scrollingElement || document.documentElement || null;
};

export const scrollContainerToBottom = (container) => {
    if (!container) return;

    container.scrollTop = container.scrollHeight;
};
